import * as React from 'react';
import { useSelector } from 'react-redux';
import { useDeviceType } from '@cian/ui-kit';
import { selectDescription, selectDescriptionMarkup } from '../../selectors';
import { Description, DescriptionMobile } from '../../components/Description';

export const DescriptionContainer = () => {
  const deviceType = useDeviceType();
  const description = useSelector(selectDescription);
  const descriptionMarkup = useSelector(selectDescriptionMarkup);

  if (!description) {
    return null;
  }

  const DescriptionComponent = deviceType === 'desktop' ? Description : DescriptionMobile;

  return <DescriptionComponent text={description} html={descriptionMarkup} />;
};
